export const USER_MODAL_ON: string = 'USER_MODAL_ON';
export const USER_MODAL_OFF: string = 'USER_MODAL_OFF';